<template>
  <slot></slot>
  <ToastContainer :toasts="toasts" @remove="removeToast" />
</template>

<script setup lang="ts">
import { ref, provide, onMounted } from 'vue';
import ToastContainer from './ToastContainer.vue';
import type { Toast } from "@/types/components/toast";
import { ToastSymbol } from "@/composables/useToast";
import { toastService } from "@/services/toastService";

const toasts = ref<Toast[]>([]);

const addToast = (newToast: Omit<Toast, 'id'>) => {
  const id = Math.random().toString(36).substring(2, 9);
  const toast = { ...newToast, id };

  toasts.value = [...toasts.value, toast];

  if (newToast.duration !== Infinity) {
    setTimeout(() => {
      removeToast(id);
    }, newToast.duration || 5000);
  }
};

const removeToast = (id: string) => {
  toasts.value = toasts.value.filter(toast => toast.id !== id);
};

// Provide for component-based usage
provide(ToastSymbol, addToast);

// Register with the global service
onMounted(() => {
  toastService.registerHandler(addToast);
});
</script>